import { Shop } from '@@types'
import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'


import Button from '@shared/ui/button'

import styles from './PickupView.module.scss'



export const ShopDetails = ({
  selectedShop,
  open,
  close,
  getShopStatus,
  handleSelectShop,
}: {
  selectedShop: Shop | null;
  open: string;
  close: string;
  getShopStatus: boolean;
  handleSelectShop: (shop: Shop) => void;
}) => {
  const { t: tmd } = useTranslation('modalDelivery')
  if (!selectedShop) return null

  return (
    <div className={styles.details}>
      <h3 className={styles.details__address}>{selectedShop.address}</h3>
      <div className={styles.details__time}>
        {!getShopStatus ? (
          <ReactSVG src="/icons/system.svg" wrapper="span" />
        ) : null}
        <p>
          {/* Ежедневно с {open} до {close} */}
          {tmd('daily.open_hours', { open: open, close: close })}
          <span data-status={getShopStatus}>
            {getShopStatus ? tmd('status.open') : tmd('status.closed')}
          </span>
        </p>
      </div>
      {selectedShop.phone ? (
        <span className={styles.details__phone}>
          <ReactSVG src="/icons/devices.svg" wrapper="span" />
          <a href={`tel:${selectedShop.phone}`}>{selectedShop.phone}</a>
        </span>
      ) : null}

      <div className={styles.details__controls}>
        <Button onClick={() => handleSelectShop(selectedShop)}>
          {tmd('select')}
        </Button>
        <Button
          theme="secondary"
          onClick={() => {
            const { latitude, longitude } = selectedShop.shopGeoPoint || {}
            if (latitude && longitude) {
              const url = `https://yandex.ru/maps/?rtext=~${latitude},${longitude}&rtt=auto`
              window.open(url, '_blank')
            }
          }}
        >
          {tmd('route')}
        </Button>
      </div>
    </div>
  )
}
